import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Static files of languages.
import enStrings from './resources/en';
import zhStrings from './resources/zh-TW';
import cnStrings from './resources/zh-CN';

i18n
  .use(LanguageDetector)
  .init({
    // we init with resources
    resources: {
      zh: {
        translations: zhStrings,
      },
      cn: {
        translations: cnStrings,
      },
      en: {
        translations: enStrings,
      },
    },
    fallbackLng: 'zh',
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
    },

    react: {
      wait: true,
    },
  });

export default i18n;
